import PropTypes from "prop-types";
/**
 * Created by fers on 25.07.16.
 */

import Relay from 'react-relay';

// TODO: Rename file to SetUserNotificationsMutation.react.js?

export default class SetUserNotificationsMutation extends Relay.Mutation {
  static propTypes = {
    user_id: PropTypes.string.isRequired,
    notifyErrors: PropTypes.bool,
    notifyErrorsFreq: PropTypes.string
  };
  getMutation() {
    // Use the new mutation name
    return Relay.QL`mutation {setUserNotifications}`;
  }
  getVariables() {
    // Map props to the new input field names
    return {
      user_id: this.props.user_id,
      notifyErrors: this.props.notifyErrors,
      notifyErrorsFreq: this.props.notifyErrorsFreq
    };
  }

  getFatQuery() {
    // Update the fragment to match the new payload structure
    return Relay.QL`
            fragment on SetUserNotificationsPayload {
                updatedNode {
                    id,
                    notifyErrors,
                    notifyErrorsFreq
                }
            }
        `;
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE', // Use FIELDS_CHANGE for updating existing nodes
      fieldIDs: {
        updatedNode: this.props.user_id // Map the updatedNode to the user ID
      }
    }];
  }
}